import { API_URL } from '../config';
import {useTranslation} from "react-i18next";
export const GetReportMethods = async () => {
    try {
        return [
            {
                value: 'email',
                label: 'Email'
            },
            {
                value: 'sftp',
                label: 'SFTP'
            },
            {
                value: 'email_and_sftp',
                label: 'Email and SFTP'
            },
            {
                value: 'sftp_push',
                label: 'SFTP push'
            },
        ];

    } catch (error) {
        console.error('Error fetching report types:', error);
        throw error;
    }
};